import { IObservable, Subject } from '~/rage/utils';
import { ClothesComponentId } from '~/shared';
import { IClothesTesterService, IComponent } from './clothesTesterServiceTypes';

export class ClothesTesterServiceStub implements IClothesTesterService {
	private components = new Subject<
		Partial<Record<ClothesComponentId, IComponent>>
	>({});

	constructor() {
		const initialComponents: Partial<Record<ClothesComponentId, IComponent>> =
			{};

		for (let i = 0; i <= ClothesComponentId.BRACELETS; i++) {
			initialComponents[i as ClothesComponentId] = {
				drawable: 0,
				texture: 0,
			};
		}

		this.components.next(initialComponents);
	}

	public async getComponentDrawablesCount(
		componentId: number,
	): Promise<number> {
		if (componentId >= ClothesComponentId.HATS) {
			console.log('clothesTester:getPropDrawablesCount', {
				componentId: componentId - ClothesComponentId.HATS,
			});
		} else {
			console.log('clothesTester:getComponentDrawablesCount', {
				componentId,
			});
		}

		return 0;
	}

	public async getComponentTexturesCount(
		componentId: number,
		drawableId: number,
	): Promise<number> {
		if (componentId >= ClothesComponentId.HATS) {
			console.log('clothesTester:getPropTexturesCount', {
				componentId: componentId - ClothesComponentId.HATS,
				drawableId,
			});
		} else {
			console.log('clothesTester:getComponentTexturesCount', {
				componentId,
				drawableId,
			});
		}

		return 0;
	}

	public getComponents(): IObservable<Record<ClothesComponentId, IComponent>> {
		return this.components as IObservable<
			Record<ClothesComponentId, IComponent>
		>;
	}

	public async applyComponents(
		componentId: number,
		drawableId: number,
		textureId: number,
		torsoDrawableId: number,
		torsoTextureId: number,
		undershirtDrawableId: number,
		undershirtTextureId: number,
		isHatHidden: boolean,
		areGlassesHidden: boolean,
		isBellyOpen: boolean,
	): Promise<void> {
		console.log('clothesTester:applyComponents', {
			componentId,
			drawableId,
			textureId,
			torsoDrawableId,
			torsoTextureId,
			undershirtDrawableId,
			undershirtTextureId,
			isHatHidden,
			areGlassesHidden,
			isBellyOpen,
		});
	}

	public async lookAtComponent(componentId: ClothesComponentId): Promise<void> {
		console.log('clothesTester:lookAtComponent', { componentId });
	}

	public async exit(): Promise<void> {
		console.log('clothesTester:exit');
	}
}
